<template>
  <div>
    <card-default v-bind="$attrs" v-if="contentType === 'theme_flxmenu'" />
    <card-product v-bind="$attrs" v-if="contentType === 'allInOneProductList'" />
    <card-custom v-bind="$attrs" v-if="contentType === 'theme_flxslides'" />
    <card-science-lab v-bind="$attrs" v-if="contentType === 'sciencelab'" />
    <card-event v-bind="$attrs" v-if="contentType === 'events'" />
  </div>
</template>

<script>
import CardDefault from "@/components/Card/CardDefault";
import CardProduct from "@/components/Card/CardProduct";
import CardCustom from "@/components/Card/CardCustom";
import CardEvent from "@/components/Card/CardEvent";
import CardScienceLab from "@/components/Card/CardScienceLab";
export default {
  name: "Card",
  inheritAttrs: false,
  components: {
    CardDefault,
    CardProduct,
    CardCustom,
    CardEvent,
    CardScienceLab,
  },
  props: {
    contentType: String,
  },
};
</script>